import type { Namespace } from './types';
export const zh: Namespace = {
  accounts: {
    states: {
      10: '离线',
      40: '在线',
      unknown: '未知状态',
    },
    loginStages: {
      10: '待登录',
      20: '登录中',
      30: '邮箱验证',
      32: '令牌验证',
      40: '成功',
      60: '失败',
      80: '异常',
      unknown: '未知阶段',
    },
  },
};
export const en: Namespace = {
  accounts: {
    states: {
      10: 'Offline',
      40: 'Online',
      unknown: 'Unknown state',
    },
    loginStages: {
      10: 'Pending',
      20: 'Signing in',
      30: 'Email code',
      32: '2FA code',
      40: 'Success',
      60: 'Failed',
      80: 'Error',
      unknown: 'Unknown stage',
    },
  },
};
